// extracted by mini-css-extract-plugin
export default {"searchBorder":"SearchLocationWidget_searchBorder__7zX-T"};